/** Planned exam marks never go past this. New assessments use the cap. */
export const ASSESSMENT_MARKS_CAP = 100

export function clampAssessmentMarks(marks: number): number {
  if (!Number.isFinite(marks) || marks <= 0) return 0
  return Math.min(ASSESSMENT_MARKS_CAP, Math.round(marks))
}

/** Keep a paper at or under the assessment mark cap. Highest-point items give first. */
export function scalePaperMarksToCap<T extends { points: number }>(
  paper: T[],
  cap: number = ASSESSMENT_MARKS_CAP,
): T[] {
  const total = paper.reduce((sum, row) => sum + row.points, 0)
  if (total <= cap || paper.length === 0) return paper

  let overflow = total - cap
  const next = paper.map((row) => ({ ...row }))
  const order = next
    .map((_, index) => index)
    .sort((left, right) => next[right]!.points - next[left]!.points)

  for (const index of order) {
    if (overflow <= 0) break
    const row = next[index]!
    const take = Math.min(overflow, Math.max(0, row.points - 1))
    row.points -= take
    overflow -= take
  }

  return next
}
